import { Injectable } from '@angular/core';
import { CrudService } from './crud.service';

@Injectable({ providedIn: 'root' })
export class SaldoMotoristaService {
  constructor(private crud: CrudService) {}

  getMyBalance() {
    return this.crud.getData('saldo-motorista/me');
  }

  requestWithdrawal(valor: number, metodoRecebimento: string) {
    return this.crud.postData('saldo-motorista/saque', '', { valor, metodoRecebimento });
  }

  listMyWithdrawals() {
    return this.crud.getData('saldo-motorista/saques');
  }
}
